require('angular').module('wowApp.common')
    .service('StackchatService', ['$state', '$document', 'SettingsService', require('./stackchat-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/stackchat/index.js
 **/